import gql from "graphql-tag";

export const ADD_CITY = gql`
 mutation insert_city($id: uuid!,$city: String!,$shortCode: String!,$state: String!,$country: String!) {
  insert_city(objects: {id: $id, city: $city, shortCode: $shortCode, state: $state, country: $country}) {
    returning {
      id
 }
}
  }
`

export const UPDATE_CITY = gql`
 mutation ($cityId: uuid!,$city: String!,$shortCode: String!,$state: String!,$country: String!) {
   update_city (where: {id: {_eq: $cityId}}, _set: {city: $city, shortCode: $shortCode, state: $state, country: $country}) {
    returning {
      id
     }
    } 
  }
`
export const DELETE_CITY = gql`
 mutation ($cityId: uuid!) {
   delete_city(where: {id: {_eq: $cityId}}) {
    returning {
      id
     }
    }   
  }
`